(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1137],{

/***/ 49455:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varPrimary100":"var(--tkww-union-color-primary-100, #FFE4FB)","varPrimary200":"var(--tkww-union-color-primary-200, #FEBBF7)","varPrimary300":"var(--tkww-union-color-primary-300, #FF44CB)","varPrimary400":"var(--tkww-union-color-primary-400, #D700A0)","varPrimary500":"var(--tkww-union-color-primary-500, #AC007C)","varNeutral100":"var(--tkww-union-color-neutral-100, #F1F2F4)","varNeutral200":"var(--tkww-union-color-neutral-200, #E4E5E9)","varNeutral300":"var(--tkww-union-color-neutral-300, #CACCD0)","varNeutral400":"var(--tkww-union-color-neutral-400, #9699A0)","varNeutral500":"var(--tkww-union-color-neutral-500, #51545C)","varNeutral600":"var(--tkww-union-color-neutral-600, #37393F)","varNeutralBlack":"var(--tkww-union-color-neutral-black, #000)","varNeutralWhite":"var(--tkww-union-color-neutral-white, #FFF)","varStatusError100":"var(--tkww-union-color-status-error-100, #FFECE4)","varStatusError200":"var(--tkww-union-color-status-error-200, #EB1400)","varStatusError300":"var(--tkww-union-color-status-error-300, #A1000B)","varStatusInfo100":"var(--tkww-union-color-status-info-100, #F4F9FF)","varStatusInfo200":"var(--tkww-union-color-status-info-200, #0073E6)","varStatusInfo300":"var(--tkww-union-color-status-info-300, #114394)","varStatusSuccess100":"var(--tkww-union-color-status-success-100, #E2FFEE)","varStatusSuccess200":"var(--tkww-union-color-status-success-200, #008A05)","varStatusSuccess300":"var(--tkww-union-color-status-success-300, #005A25)","varStatusWarning100":"var(--tkww-union-color-status-warning-100, #FFF3DD)","varStatusWarning200":"var(--tkww-union-color-status-warning-200, #C25400)","varStatusWarning300":"var(--tkww-union-color-status-warning-300, #823300)","varAdditional01Extra100":"var(--tkww-union-color-additional-01extra-100, #E6F2FC)","varAdditional01Extra200":"var(--tkww-union-color-additional-01extra-200, #C4DFF9)","varAdditional01Extra300":"var(--tkww-union-color-additional-01extra-300, #A1CDF5)","varAdditional01Extra400":"var(--tkww-union-color-additional-01extra-400, #0073E6)","varAdditional01Extra500":"var(--tkww-union-color-additional-01extra-500, #364C9D)","varAdditional02Extra100":"var(--tkww-union-color-additional-02extra-100, #FFF7E1)","varAdditional02Extra200":"var(--tkww-union-color-additional-02extra-200, #FDDE81)","varAdditional02Extra300":"var(--tkww-union-color-additional-02extra-300, #FBBB03)","varAdditional02Extra400":"var(--tkww-union-color-additional-02extra-400, #FBAF00)","varAdditional02Extra500":"var(--tkww-union-color-additional-02extra-500, #FB8B00)","varAdditional03Extra100":"var(--tkww-union-color-additional-03extra-100, #FFD1BD)","varAdditional03Extra200":"var(--tkww-union-color-additional-03extra-200, #FF9357)","varAdditional03Extra300":"var(--tkww-union-color-additional-03extra-300, #FF6F00)","varAdditional03Extra400":"var(--tkww-union-color-additional-03extra-400, #FA592D)","varAdditional03Extra500":"var(--tkww-union-color-additional-03extra-500, #DB4936)","varAdditional04Extra100":"var(--tkww-union-color-additional-04extra-100, #FFF5ED)","varAdditional04Extra200":"var(--tkww-union-color-additional-04extra-200, #F7E6DC)","varAdditional04Extra300":"var(--tkww-union-color-additional-04extra-300, #E8D5CA)","varAdditional04Extra400":"var(--tkww-union-color-additional-04extra-400, #C7AFA1)","varAdditional04Extra500":"var(--tkww-union-color-additional-04extra-500, #AD9587)","varBackgroundActive":"var(--tkww-union-color-background-active, var(--tkww-union-color-additional-04extra-100, #FFF5ED))","varBackgroundDark":"var(--tkww-union-color-background-dark, var(--tkww-union-color-neutral-black, #000))","varBackgroundDarkContrast":"var(--tkww-union-color-background-dark-contrast, var(--tkww-union-color-neutral-400, #9699A0))","varBackgroundError":"var(--tkww-union-color-background-error, var(--tkww-union-color-status-error-100, #FFECE4))","varBackgroundLight":"var(--tkww-union-color-background-light, var(--tkww-union-color-neutral-white, #FFF))","varBackgroundLightContrast":"var(--tkww-union-color-background-light-contrast, var(--tkww-union-color-neutral-100, #F1F2F4))","varBackgroundLightContrast2":"var(--tkww-union-color-background-light-contrast-2, var(--tkww-union-color-neutral-200, #E4E5E9))","varBackgroundSuccess":"var(--tkww-union-color-background-success, var(--tkww-union-color-status-success-100, #E2FFEE))","varBackgroundWarning":"var(--tkww-union-color-background-warning, var(--tkww-union-color-status-warning-100, #FFF3DD))","varBorderDarkDefault":"var(--tkww-union-color-border-dark-default, var(--tkww-union-color-neutral-black, #000))","varBorderDefault":"var(--tkww-union-color-border-default, var(--tkww-union-color-neutral-300, #CACCD0))","varBorderError":"var(--tkww-union-color-border-error, var(--tkww-union-color-status-error-200, #EB1400))","varBorderSelected":"var(--tkww-union-color-border-selected, var(--tkww-union-color-neutral-500, #51545C))","varBorderSuccess":"var(--tkww-union-color-border-success, var(--tkww-union-color-status-success-200, #008A05))","varBorderWarning":"var(--tkww-union-color-border-warning, var(--tkww-union-color-status-warning-200, #C25400))","varBrandPrimary":"var(--tkww-union-color-brand-primary, var(--tkww-union-color-primary-300, #FF44CB))","varCtaDarkDefault":"var(--tkww-union-color-cta-dark-default, var(--tkww-union-color-neutral-black, #000))","varCtaDarkDefaultDisabled":"var(--tkww-union-color-cta-dark-default-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varCtaDarkDefaultHover":"var(--tkww-union-color-cta-dark-default-hover, var(--tkww-union-color-neutral-600, #37393F))","varCtaDefault":"var(--tkww-union-color-cta-default, var(--tkww-union-color-primary-300, #FF44CB))","varCtaDisabled":"var(--tkww-union-color-cta-disabled, var(--tkww-union-color-primary-200, #FEBBF7))","varCtaHover":"var(--tkww-union-color-cta-hover, var(--tkww-union-color-primary-400, #D700A0))","varDividerDefault":"var(--tkww-union-color-divider-default, var(--tkww-union-color-neutral-300, #CACCD0))","varIconCta":"var(--tkww-union-color-icon-cta, var(--tkww-union-color-primary-400, #D700A0))","varIconDefault":"var(--tkww-union-color-icon-default, var(--tkww-union-color-neutral-black, #000))","varIconOnDarkDefault":"var(--tkww-union-color-icon-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","varIconSubtle":"var(--tkww-union-color-icon-subtle, var(--tkww-union-color-neutral-500, #51545C))","varLinkOnLight":"var(--tkww-union-color-link-on-light, var(--tkww-union-color-additional-01extra-400, #0073E6))","varLinkOnLightDisabled":"var(--tkww-union-color-link-on-light-disabled, var(--tkww-union-color-additional-01extra-200, #C4DFF9))","varLinkOnLightHover":"var(--tkww-union-color-link-on-light-hover, var(--tkww-union-color-additional-01extra-400, #0073E6))","varLinkOnDark":"var(--tkww-union-color-link-on-dark, var(--tkww-union-color-neutral-white, #FFF))","varLinkOnDarkDisabled":"var(--tkww-union-color-link-on-dark-disabled, var(--tkww-union-color-neutral-400, #9699A0))","varLinkDarkOnLight":"var(--tkww-union-color-link-dark-on-light, var(--tkww-union-color-neutral-black, #000))","varLinkDarkOnLightDisabled":"var(--tkww-union-color-link-dark-on-light-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varLinkGrayOnLight":"var(--tkww-union-color-link-gray-on-light, var(--tkww-union-color-neutral-500, #51545C))","varLinkGrayOnLightDisabled":"var(--tkww-union-color-link-gray-on-light-disabled, var(--tkww-union-color-neutral-200, #E4E5E9))","varTextBrand":"var(--tkww-union-color-text-brand, var(--tkww-union-color-primary-400, #D700A0))","varTextDefault":"var(--tkww-union-color-text-default, var(--tkww-union-color-neutral-black, #000))","varTextDisabled":"var(--tkww-union-color-text-disabled, var(--tkww-union-color-neutral-300, #CACCD0))","varTextError":"var(--tkww-union-color-text-error, var(--tkww-union-color-status-error-200, #EB1400))","varTextOnDarkDefault":"var(--tkww-union-color-text-on-dark-default, var(--tkww-union-color-neutral-white, #FFF))","varTextOnDarkSubtle":"var(--tkww-union-color-text-on-dark-subtle, var(--tkww-union-color-neutral-300, #CACCD0))","varTextSubtle":"var(--tkww-union-color-text-subtle, var(--tkww-union-color-neutral-500, #51545C))","varTextSuccess":"var(--tkww-union-color-text-success, var(--tkww-union-color-status-success-200, #008A05))","varTextWarning":"var(--tkww-union-color-text-warning, var(--tkww-union-color-status-warning-200, #C25400))","varWhite":"var(--tkww-union-color-white, var(--tkww-union-color-neutral-white, #FFF))","varCoolgray100":"var(--tkww-union-color-coolgray-100, var(--tkww-union-color-neutral-100, #F1F2F4))","varCoolgray200":"var(--tkww-union-color-coolgray-200, var(--tkww-union-color-neutral-200, #E4E5E9))","varCoolgray300":"var(--tkww-union-color-coolgray-300, var(--tkww-union-color-neutral-300, #CACCD0))","varCoolgray400":"var(--tkww-union-color-coolgray-400, var(--tkww-union-color-neutral-400, #9699A0))","varCoolgray500":"var(--tkww-union-color-coolgray-500, var(--tkww-union-color-neutral-500, #51545C))","varGold100":"var(--tkww-union-color-gold-100, var(--tkww-union-color-additional-02extra-100, #FFF7E1))","varGold200":"var(--tkww-union-color-gold-200, var(--tkww-union-color-additional-02extra-100, #FFF7E1))","varGold300":"var(--tkww-union-color-gold-300, var(--tkww-union-color-additional-02extra-200, #FDDE81))","varGold400":"var(--tkww-union-color-gold-400, var(--tkww-union-color-additional-02extra-300, #FBBB03))","varGold500":"var(--tkww-union-color-gold-500, var(--tkww-union-color-additional-02extra-400, #FBAF00))","varGold900":"var(--tkww-union-color-gold-900, var(--tkww-union-color-additional-02extra-500, #FB8B00))","varIndigo400":"var(--tkww-union-color-indigo-400, var(--tkww-union-color-additional-01extra-100, #E6F2FC))","varIndigo500":"var(--tkww-union-color-indigo-500, var(--tkww-union-color-additional-01extra-100, #E6F2FC))","varIndigo600":"var(--tkww-union-color-indigo-600, var(--tkww-union-color-additional-01extra-200, #C4DFF9))","varIndigo650":"var(--tkww-union-color-indigo-650, var(--tkww-union-color-additional-01extra-300, #A1CDF5))","varIndigo700":"var(--tkww-union-color-indigo-700, var(--tkww-union-color-additional-01extra-300, #A1CDF5))","varIndigo800":"var(--tkww-union-color-indigo-800, var(--tkww-union-color-additional-01extra-400, #0073E6))","varIndigo900":"var(--tkww-union-color-indigo-900, var(--tkww-union-color-additional-01extra-500, #364C9D))","varMidnight":"var(--tkww-union-color-midnight, var(--tkww-union-color-neutral-600, #37393F))","varPeach300":"var(--tkww-union-color-peach-300, var(--tkww-union-color-additional-03extra-100, #FFD1BD))","varPeach400":"var(--tkww-union-color-peach-400, var(--tkww-union-color-additional-03extra-100, #FFD1BD))","varPeach500":"var(--tkww-union-color-peach-500, var(--tkww-union-color-additional-03extra-100, #FFD1BD))","varRaspberry200":"var(--tkww-union-color-raspberry-200, var(--tkww-union-color-primary-100, #FFE4FB))","varRaspberry300":"var(--tkww-union-color-raspberry-300, var(--tkww-union-color-primary-200, #FEBBF7))","varRaspberry400":"var(--tkww-union-color-raspberry-400, var(--tkww-union-color-primary-400, #D700A0))","varRaspberry500":"var(--tkww-union-color-raspberry-500, var(--tkww-union-color-primary-500, #AC007C))","varTeal100":"var(--tkww-union-color-teal-100, var(--tkww-union-color-status-success-100, #E2FFEE))","varTeal200":"var(--tkww-union-color-teal-200, var(--tkww-union-color-status-success-100, #E2FFEE))","varTeal300":"var(--tkww-union-color-teal-300, var(--tkww-union-color-status-success-200, #008A05))","varTeal400":"var(--tkww-union-color-teal-400, var(--tkww-union-color-status-success-200, #008A05))","varTeal500":"var(--tkww-union-color-teal-500, var(--tkww-union-color-status-success-300, #005A25))","varTeal600":"var(--tkww-union-color-teal-600, var(--tkww-union-color-status-success-300, #005A25))","varTkred100":"var(--tkww-union-color-tkred-100, var(--tkww-union-color-primary-100, #FFE4FB))","varTkred200":"var(--tkww-union-color-tkred-200, var(--tkww-union-color-primary-200, #FEBBF7))","varTkred300":"var(--tkww-union-color-tkred-300, var(--tkww-union-color-primary-300, #FF44CB))","varTkred400":"var(--tkww-union-color-tkred-400, var(--tkww-union-color-primary-400, #D700A0))","varTkred500":"var(--tkww-union-color-tkred-500, var(--tkww-union-color-primary-500, #AC007C))","varTkred600":"var(--tkww-union-color-tkred-600, var(--tkww-union-color-primary-500, #AC007C))"};

/***/ }),

/***/ 26968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_Carousel; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(21818);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-carousel/lib/BaseCarousel/index.js + 15 modules
var BaseCarousel = __webpack_require__(72848);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/global-this.js
var global_this = __webpack_require__(26111);
var global_this_default = /*#__PURE__*/__webpack_require__.n(global_this);
;// CONCATENATED MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ var ResizeObserver_es = (index);

;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/getNewWidths/index.js
const calcWidthsMinMax = _ref => {
  let {
    minSlideWidth,
    maxSlideWidth,
    gutter,
    width
  } = _ref;
  if (minSlideWidth > maxSlideWidth) {
    throw new Error('minSlideWidth cannot be greater maxSlideWidth');
  }
  const containerToSlideRatio = width / (minSlideWidth + gutter);
  const possibleSlides = Math.floor(containerToSlideRatio);
  const slideWidth = Math.min(width / possibleSlides, maxSlideWidth + gutter);
  return {
    containerWidth: width,
    slideWidth,
    maskWidth: possibleSlides === 0 ? minSlideWidth : possibleSlides * slideWidth
  };
};
const calcWidthsNumSlides = _ref2 => {
  let {
    slides,
    width
  } = _ref2;
  const slideWidth = Math.floor(width / slides);
  return {
    containerWidth: width,
    slideWidth,
    maskWidth: width
  };
};
const getNewWidths = (_ref3, containerRef) => {
  let {
    responsive,
    ...props
  } = _ref3;
  const {
    width
  } = containerRef.current.getBoundingClientRect();
  const {
    slides,
    ...responsiveResult
  } = responsive({
    width
  });
  if (!slides) {
    return calcWidthsMinMax({
      ...props,
      ...responsiveResult,
      width
    });
  }
  return calcWidthsNumSlides({
    slides,
    width
  });
};
/* harmony default export */ var lib_getNewWidths = (getNewWidths);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useResizeObserver/index.js





const useResizeObserver = (_ref, _ref2) => {
  let {
    minSlideWidth,
    maxSlideWidth,
    gutter,
    responsive
  } = _ref;
  let {
    containerRef,
    totalSlidesCount
  } = _ref2;
  const [slideWidth, setSlideWidth] = react.useState(0);
  const [maskWidth, setMaskWidth] = react.useState(0);
  const [containerWidth, setContainerWidth] = react.useState(0);
  const resizeObserver = react.useRef();
  const animationFrameID = react.useRef();
  react.useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return (noop_default());
    }
    const updateWidthData = () => {
      const newWidths = lib_getNewWidths({
        minSlideWidth,
        maxSlideWidth,
        gutter,
        responsive
      }, containerRef);
      setSlideWidth(newWidths.slideWidth);
      setMaskWidth(newWidths.maskWidth);
      setContainerWidth(newWidths.containerWidth);
    };
    resizeObserver.current = new ResizeObserver_es(() => {
      global_this_default().cancelAnimationFrame(animationFrameID.current);
      animationFrameID.current = global_this_default().requestAnimationFrame(() => {
        updateWidthData();
      });
    });
    resizeObserver.current.observe(container);
    updateWidthData();
    return () => {
      resizeObserver.current.unobserve(container);
      global_this_default().cancelAnimationFrame(animationFrameID.current);
    };
  }, [containerRef, minSlideWidth, maxSlideWidth, gutter, responsive]);
  return react.useMemo(() => {
    const visibleSlideSlots = slideWidth && maskWidth && Math.floor(maskWidth / slideWidth) || 0;
    const visibleSlidesCount = Math.min(visibleSlideSlots, totalSlidesCount);
    const takenSlideSpace = visibleSlidesCount * slideWidth;
    const extraPixels = containerWidth - takenSlideSpace;
    return {
      slideWidth,
      containerWidth,
      maskWidth,
      visibleSlideSlots,
      visibleSlidesCount,
      extraPixels
    };
  }, [slideWidth, containerWidth, maskWidth, totalSlidesCount]);
};
/* harmony default export */ var lib_useResizeObserver = (useResizeObserver);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-carousel/lib/getSlideCount/index.js
var getSlideCount = __webpack_require__(58709);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-carousel/lib/getDefaultAlignment/index.js
var getDefaultAlignment = __webpack_require__(71493);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/Carousel/index.js











/**
 * Carousel container.
 */
const Carousel = props => {
  const {
    children,
    // resize observer props
    gutter,
    minSlideWidth,
    maxSlideWidth,
    responsive,
    ...restProps
  } = props;
  const resizeObserverProps = {
    gutter,
    minSlideWidth,
    maxSlideWidth,
    responsive
  };
  const totalSlidesCount = (0,getSlideCount/* default */.Z)(children);
  const containerRef = react.useRef();
  const resizeObserver = lib_useResizeObserver(resizeObserverProps, {
    containerRef,
    totalSlidesCount
  });
  const {
    visibleSlidesCount,
    extraPixels,
    slideWidth
  } = resizeObserver;
  const slideWidthValue = `${slideWidth}px`;
  const isReadyToRender = !!slideWidth;
  return /*#__PURE__*/react.createElement(BaseCarousel/* default */.Z, (0,esm_extends["default"])({}, restProps, {
    gutter: gutter,
    internals: {
      containerRef,
      totalSlidesCount,
      slideWidthValue,
      extraPixels,
      visibleSlidesCount,
      isReadyToRender
    }
  }), children);
};
 false ? 0 : void 0;
Carousel.defaultProps = {
  slideRole: 'group',
  carouselRole: 'group',
  pagination: 1,
  renderPrevButton: () => null,
  renderNextButton: () => null,
  alignment: getDefaultAlignment/* default */.Z,
  responsive: () => ({}),
  terms: {
    slides: {
      plural: 'slides',
      singular: 'slide'
    },
    carousel: 'carousel'
  },
  onNavigationIndexChange: (noop_default()),
  onNavigationRangeChange: (noop_default())
};
/* harmony default export */ var lib_Carousel = (Carousel);

/***/ })

}]);